import difference from "lodash/difference";
import { useSelector } from "@/redux";
import { meSliceSelector } from "@/redux/me/reducer";

export const useBankCurrencyRedemption = () => {
  const { myOffers, redemptions } = useSelector(meSliceSelector);
  const redemptionIdsAttachedToOffers = myOffers
    .map((offer) => offer.redemption?.id)
    .filter((id): id is number => id !== undefined);
  const allRedemptionsIds = redemptions.map((redemption) => redemption?.id);
  const bankedCurrencyRedemptionIds = difference(
    allRedemptionsIds,
    redemptionIdsAttachedToOffers
  );
  const bankedCurrencyRedemption = redemptions.find(
    (redemption) => redemption.id === bankedCurrencyRedemptionIds[0]
  );

  return bankedCurrencyRedemption;
};
